'use client';
import React from 'react';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card'; // Optional, if you're using shadcn/ui or similar
import { companyName } from '@/_config';

export const   ChartHomeAutomation = () => {
    const events = [
        {   step:1,
            title: 'Define Your Goals',
            icon: 'pi pi-search',
            content: 'Identify what to automate: Lighting, Climate, Security, Entertainment, Energy.'
        },
        {   step:2,
            title: 'Choose Ecosystem',
            icon: 'pi pi-sitemap',
            content: 'Pick a smart home platform: Alexa, Google Home, Apple HomeKit, SmartThings, or Home Assistant.'
        },
        {
            step:3,
            title: `Choose Devices (${companyName})`,
            icon: 'pi pi-tablet',
            content: 'Select compatible devices: Smart bulbs, plugs, thermostats, cameras, locks.'
        },
        {
            step:4,
            title: 'Install & Connect Devices',
            icon: 'pi pi-wifi',
            content: 'Connect devices to Wi-Fi and integrate with your smart home app.'
        },
        {
            step:5,
            title: 'Create Automations',
            icon: 'pi pi-cog',
            content: 'Set up automations: schedules, triggers, and routines (e.g., "Good Night").'
        }
    ];

    const customizedMarker = (item) => {
        return (
            <div className={`h-3rem w-3rem bg-white text-100 border-circle rounded-full flex align-items-center justify-content-center text-2xl font-bold`}>
                {item?.step}
            </div>
        );
    };

    const customizedContent = (item) => {
        return (
            <div className="mb-4">
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <p>{item.content}</p>
            </div>
        );
    };

    return (
        <div className="p-1">
            <h2 className="text-2xl font-bold mb-6"> Home Automation Setup Process</h2>
            <Timeline
                value={events}
                align="left"
                marker={customizedMarker}
                content={customizedContent}
                className="no-left-space-timeline"
            />
        </div>
    );
};

